import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Input, FormControl, Text, Flex, InputGroup, InputRightElement, Image, useBreakpointValue, useColorModeValue } from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import Swal from 'sweetalert2';
import { useColorMode } from "@chakra-ui/react";
import LoginController from "../../controllers/Login/LoginController";
import logo from '../../assets/img/logo_speech.png';  // Import the system logo
import outstand from '../../assets/img/logo_outstand.png';  // Import the company name image

function Login() {
  const { toggleColorMode } = useColorMode();
  
  useEffect(() => {
    const currentColorMode = localStorage.getItem('chakra-ui-color-mode');
    if (!currentColorMode) {
      toggleColorMode();
      localStorage.setItem('chakra-ui-color-mode', 'dark');
    }
  }, [toggleColorMode]);

  const [login, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const history = useHistory();

  const showToast = (icon, title) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });
    Toast.fire({
      icon,
      title
    });
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true);

    try {
      const response = await fetch('https://app.customervoice.com.br/api/v1/users_page/forgot', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          login: login, // utiliza o estado `login` como valor
        }),
      });
  
      const result = await response.json();
  
      if (response.ok && result.msg === "E-mail encaminhado com sucesso.") {


          setIsLoading(false); // Finaliza o loading

        console.log('Email enviado com sucesso:', result);
        
        // Armazena o valor de public_code no localStorage
        localStorage.setItem('public_code', result.public_code);
  
        showToast('success', 'Solicitação enviada! Verifique seu e-mail.');
        history.push("/insertCode"); // Redireciona para a próxima página
      } else {
        console.error('Erro ao enviar o e-mail:', result);
        showToast('error', 'Email não cadastrado.');
        // Permanece na página sem redirecionar
      }
    } catch (error) {
      console.error('Erro na solicitação:', error);
      showToast('error', 'Erro inesperado. Verifique sua conexão.');
    }
  };
  
  

  // Determine if video should be shown based on screen size
  const showVideo = useBreakpointValue({ base: false, md: true });

  // Set background color based on the color mode
  const backgroundColor = useColorModeValue("white", "black");

  return (
    <Flex h="100vh" direction={{ base: "column", md: "row" }}>
      {/* Left side with video (only on larger screens) */}
      {showVideo && (
        <Box flex="1" position="relative" overflow="hidden">
          <video 
            autoPlay 
            loop 
            muted 
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              opacity: "0.7",
            }}
          >
            <source src={require("../../assets/movies/login_video.webm")} type="video/mp4" />
            Seu navegador não suporta a tag de vídeo.
          </video>
          <Image 
            src={outstand} 
            alt="Company Name" 
            position="absolute" 
            top="100px"  
            left="130px" 
            boxSize="650px" 
            objectFit="contain" 
            style={{ filter: "drop-shadow(4px 2px 0px white) drop-shadow(2px 2px 2px gray)" } }
          />
        </Box>
      )}

      {/* Right side with form */}
      <Flex
        flex="1"
        align="center"
        justify="center"
        bg={backgroundColor}
        color={useColorModeValue("black", "white")}
        p="10"
      >
        <Box maxW="400px" w="100%" textAlign="center">
          <Image src={logo} alt="Customer Voice Logo" mx="auto" mb="4" boxSize="150px" objectFit="contain" 
          style={{ filter: "drop-shadow(4px 2px 1px ) drop-shadow(4px 2px 1px black)" } }/>

          <Text fontSize="xl" fontWeight="bold" mb="4">
            Recuperação de Senha
          </Text>
          <FormControl>
            <Input
              type="text"
              placeholder="Login"
              mb="2"
              size="md"
              value={login}
              onChange={(e) => setUsername(e.target.value)}
              bg="gray.800"
              color="white"
              _placeholder={{ color: "gray.400" }}
              id="login-input"
            />
            <Button
              colorScheme="blue"
              size="md"
              w="full"
              onClick={handleLogin}
              isLoading={isLoading} // Mostra um spinner automaticamente
              loadingText="Enviando..."
            >
              Enviar Solicitação
            </Button>

            <Button colorScheme="blue" size="md" w="full"  mt="2" onClick={() => history.push("/login")}>
                Voltar Login
              </Button>

            <Flex mt="4" justify="center" align="center">
              <Text onClick={() => history.push("/insertCode")} color="blue" textDecoration="underline">
                Já tenho um código válido
              </Text>
            </Flex>
          </FormControl>
        </Box>
      </Flex>
    </Flex>
  );
}

export default Login;
